import React from "react";
import CommentsList from "./CommentsList";
import FlaggedCommentsList from "./FlaggedCommentsList";
import CommentsModerator from "./CommentsModerator";
export default function Comments(){
  return (<div className="Comments">
      <CommentsModerator limit={20}/>
      <FlaggedCommentsList limit={10}/>
      <CommentsList title="All Comments" limit={30}/>
      
    </div>);
}
